import actionTypes from "constants/configs";
import { handleActions } from "redux-actions";

const { SET_CONFIGS } = actionTypes;

const initialState = {};

export default handleActions<{}, {}>(
    {
        [SET_CONFIGS]: (_state, { payload }) => ({
            ...payload,
        }),
    },
    initialState,
);
